import React from 'react';
import { ObalMaterialuNrSrBezchybnostFormData } from '../../model/pracovnyKrok/ObalMaterialuNrSrBezchybnostFormData';

export interface PodpisPredsedaFormDataContextContent {
  obalMaterialuFormData?: ObalMaterialuNrSrBezchybnostFormData,
  setObalMaterialuFormData?: (obalMaterialu: ObalMaterialuNrSrBezchybnostFormData) => void,
  generatedFile?: File;
  setGeneratedFile?: (file: File) => void,
}

export default React.createContext<PodpisPredsedaFormDataContextContent>({
  obalMaterialuFormData: undefined,
  setObalMaterialuFormData: undefined,
  generatedFile: undefined,
  setGeneratedFile: undefined,
});
